module.exports = __webpack_public_path__ + "img/crmjdn_home.14a3ebbf.png";